import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

// O "?" de cada atividade da Verificação de atividades (Adnéia, 23/10/2026): o manual de como
// fazer. O texto vem do backend (data/manuais_atividade.py, GET /api/dashboard/manuais-atividade).
// A ordem do dia abre já aberta; o resto abre no clique, para quando houver dúvida.

const Item = ({ item }) => (
  <div className="space-y-1">
    <p className="text-sm">
      {item.termo && <b>{item.termo}: </b>}
      {item.texto}
    </p>
    {item.fazer && <p className="text-sm"><span className="font-semibold text-emerald-700 dark:text-emerald-300">Fazer:</span> {item.fazer}</p>}
    {item.subitens?.length > 0 && (
      <ul className="list-disc space-y-0.5 pl-5 text-sm">
        {item.subitens.map((s, i) => <li key={i}>{s}</li>)}
      </ul>
    )}
  </div>
);

const ManualAtividade = ({ nome, manual, onClose }) => {
  const [abertas, setAbertas] = useState({});

  useEffect(() => {
    if (!manual) return;
    const a = {};
    manual.secoes.forEach((s, i) => { if (s.aberta) a[i] = true; });
    setAbertas(a);
  }, [manual]);

  if (!nome || !manual) return null;

  return (
    <Dialog open={!!nome} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{nome} · como fazer</DialogTitle>
          <DialogDescription>{manual.resumo}</DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 rounded-md bg-muted/60 px-3 py-2 text-sm">
          <span className="font-semibold whitespace-nowrap">Quando</span><span>{manual.quando}</span>
          <span className="font-semibold whitespace-nowrap">Onde</span><span>{manual.onde}</span>
        </div>

        {manual.secoes.map((s, i) => {
          const aberta = !!abertas[i];
          return (
            <div key={s.titulo} className="border-t pt-2">
              <button type="button" aria-expanded={aberta}
                onClick={() => setAbertas(p => ({ ...p, [i]: !p[i] }))}
                className="flex w-full items-center gap-1.5 text-left text-sm font-bold uppercase tracking-wide text-slate-700 hover:text-primary dark:text-slate-200">
                {aberta ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                {s.titulo}
              </button>
              {aberta && (s.numerada ? (
                <ol className="mt-2 list-decimal space-y-2 pl-6">
                  {s.itens.map((it, j) => <li key={j}><Item item={it} /></li>)}
                </ol>
              ) : (
                <div className="mt-2 space-y-3 pl-1">
                  {s.itens.map((it, j) => <Item key={j} item={it} />)}
                </div>
              ))}
            </div>
          );
        })}
      </DialogContent>
    </Dialog>
  );
};

export default ManualAtividade;
